import { getTmsInstance } from "integration-web-core--socle/js/assets/commons/_tms";
const pushTmsFragment = getTmsInstance().prepareFragment();
lm.DOMReady(() => {
  const tmsDataElement = document.getElementById("arm-pad-tms-data");
  const tmsFragment = tmsDataElement ? JSON.parse(tmsDataElement.textContent) : [];
  pushTmsFragment(tmsFragment);
});